import {v4 as uuidv4} from "uuid";
import moment from "moment";
import { isArrayWithLength } from "../../utils/array-methods";

const SCOPE_TYPE = {
  ACCOUNT: "Account",
  PROJECT: "Project",
};

export const addReviewData = async (data) => {
  let workloadScope = [];

  const scopeType = isArrayWithLength(data.Scope.Accounts)
    ? SCOPE_TYPE.ACCOUNT
    : SCOPE_TYPE.PROJECT;

  if (scopeType === SCOPE_TYPE.ACCOUNT) {
    const selectedAcc = data.Scope.Accounts.find((acc) => {
      return isArrayWithLength(acc.Regions);
    });

    workloadScope = [selectedAcc];
  } else {
    workloadScope = [data.Scope.Department];
  }

  return {
    AnsweredQuestions: 0,
    CreatedAt: moment(),
    Description: data.Description,
    DiagramURL: null,
    Environment: data.Environment,
    ImprovementStatus: "NOT_APPLICABLE",
    InSync: 1,
    Industry: "Computer_Electronics",
    IndustryType: "InfoTech",
    Lenses: "AWS Well-Architected Framework",
    Owner: "Cibi",
    RegionCode: data.RegionCode,
    RiskCounts: {
      High: 0,
      Medium: 0,
    },
    Scope: workloadScope,
    Status: "PENDING",
    TotalQuestions: 58,
    UpdatedAt: moment(),
    WorkloadArn:
      "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
    WorkloadId: uuidv4(),
    WorkloadName: data.WorkloadName,
  };
};

export const updateReviewData = (review) => {
  return {
    LensAlias: "wellarchitected",
    LensArn: "arn:aws:wellarchitected::aws:lens/wellarchitected",
    LensName: "AWS Well-Architected Framework",
    LensStatus: "CURRENT",
    LensVersion: "2022-03-31",
    PillarReviewSummaries: [
      {
        PillarId: "security",
        PillarName: "Security",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 10,
        },
      },
      {
        PillarId: "performance",
        PillarName: "Performance Efficiency",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 8,
        },
      },
      {
        PillarId: "reliability",
        PillarName: "Reliability",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 13,
        },
      },
      {
        PillarId: "costOptimization",
        PillarName: "Cost Optimization",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 10,
        },
      },
      {
        PillarId: "sustainability",
        PillarName: "Sustainability",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 6,
        },
      },
      {
        PillarId: "operationalExcellence",
        PillarName: "Operational Excellence",
        RiskCounts: {
          HIGH: 0,
          MEDIUM: 0,
          NONE: 0,
          NOT_APPLICABLE: 0,
          UNANSWERED: 11,
        },
      },
    ],
    RiskCounts: {
      HIGH: 0,
      MEDIUM: 0,
      NONE: 0,
      NOT_APPLICABLE: 0,
      UNANSWERED: 58,
    },
    UpdatedAt: moment(),
    WorkloadSummary: {
      AnsweredQuestions: 0,
      CreatedAt: moment(),
      Description: review.Description,
      DiagramURL: null,
      Environment: review.Environment,
      ImprovementStatus: "NOT_APPLICABLE",
      InSync: 1,
      Industry: "Computer_Electronics",
      IndustryType: "InfoTech",
      Lenses: "AWS Well-Architected Framework",
      Owner: "Cibi",
      RegionCode: review.RegionCode,
      RiskCounts: {
        High: 0,
        Medium: 0,
      },
      Scope: review.Scope,
      Status: "PENDING",
      TotalQuestions: 58,
      UpdatedAt: moment(),
      WorkloadArn:
        "arn:aws:wellarchitected:us-east-1:688736627613:workload/c85724c7cd1392a22b3c0059064baf5e",
      WorkloadId: review.WorkloadId,
      WorkloadName: review.WorkloadName,
    },
  };
};

export const createReview = async (data) => {
  const reviewData = await addReviewData(data);
  return reviewData;
};

export const updateReview = (data) => {
  const reviewData = updateReviewData(data);
  return reviewData;
};
